import { ReactNode } from "react";
import Image from "../Image";
import Link from "../Link";
import Video from "../Video";
import File from "../File";
import Youtube from "../Youtube";
import Facebook from "../Facebook";
import Instagram from "../Instagram";
import Contact from "../Contact";
import Use from "../Use";

export const textPreprocessor = (inputStr?: string) => {
    if (!inputStr) return '';

    let text: any = prepareText(inputStr);
    return replaceTagsWithComponents(text);
}

export const prepareText = (inputStr: string) => {
    let out = String(inputStr);

    const links = inputStr.match(/(^|[^:])((https?):\/\/[^\s/$.?#].[^\s]*)/gi)?.map(item => item.replace(/^\s*/, ''))
    links?.forEach((url) => {
        out = out.replace(
            url,
            `[link:${url}]${url}[/link]`
        );
    });

    const tags = ['image', 'video', 'yt'];
    tags.forEach(tag => {
        const tmp = inputStr.match(new RegExp(`\\[${tag}:([^\\]]+)\\]`, 'g'));
        tmp?.forEach((item) => {
            out = out.replace(
                item,
                `${item}[/${tag}]`
            );
        });
    });

    out = out.replace(/\[nl\]/g, '[nl][/nl]');

    return out;
}

type TagMappings = {
    [tag: string]: (content: ReactNode, attributes: any, key: number | string) => ReactNode;
};

//generovano ChatGPT
function processTag(tagContent: string, tagMappings: TagMappings, key: number): ReactNode[] {
    const components: ReactNode[] = [];
    const tagRegex = /\[([a-z]+)(:([^\]]+))?\](.*?)\[\/\1\]/g;

    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = tagRegex.exec(tagContent)) !== null) {
        const startIndex = match.index;
        const endIndex = tagRegex.lastIndex;

        if (startIndex > lastIndex) {
            components.push(tagContent.substring(lastIndex, startIndex));
        }

        const tagType = match[1];
        const tagAttributes = match[3];
        const innerTagContent = match[4];
        const attributes = parseTagAttributes(tagAttributes);
        const innerComponents = processTag(innerTagContent, tagMappings, startIndex);
        const component = tagMappings[tagType](innerComponents, attributes, endIndex);
        components.push(component);

        lastIndex = endIndex;
    }

    if (lastIndex < tagContent.length) {
        components.push(tagContent.substring(lastIndex));
    }

    return components;
}

function parseTagAttributes(attributeString: string): any {
    return attributeString ? { param: attributeString } : {};
}

function replaceTagsWithComponents(text: string) {
    const tagMappings: TagMappings = {
        b: (content, attributes, key) => <strong key={key}>{content}</strong>,
        u: (content, attributes, key) => <u key={key}>{content}</u>,
        i: (content, attributes, key) => <i key={key}>{content}</i>,
        nl: (content, attributes, key) => <br key={key} />,
        ul: (content, attributes, key) => <ul key={key}>{content}</ul>,
        li: (content, attributes, key) => <li key={key}>{content}</li>,
        link: (content, attributes, key) => (
            <Link url={attributes.param} key={key}>{content}</Link>
        ),
        email: (content, attributes, key) => (
            <Contact value={attributes.param} type='email' key={key}>{content}</Contact>
        ),
        tel: (content, attributes, key) => (
            <Contact value={attributes.param} type='phone' key={key}>{content}</Contact>
        ),
        image: (content, attributes, key) => (
            <Image imageId={attributes.param} key={key} />
        ),
        video: (content, attributes, key) => (
            <Video videoId={attributes.param} key={key} />
        ),
        word: (content, attributes, key) => (
            <File fileId={attributes.param} type='WORD' key={key}>{content}</File>
        ),
        pdf: (content, attributes, key) => (
            <File fileId={attributes.param} type='PDF' key={key}>{content}</File>
        ),
        file: (content, attributes, key) => (
            <File fileId={attributes.param} key={key}>{content}</File>
        ),
        yt: (content, attributes, key) => (
            <Youtube url={attributes.param} key={key} />
        ),
        instagram: (content, attributes, key) => (
            <Instagram url={attributes.param} height={content as string} key={key} />
        ),
        fb: (content, attributes, key) => (
            <Facebook url={attributes.param} height={content as string} key={key} />
        ),
        use: (content, attributes, key) => (
            <Use alt={attributes.param as string} key={key}>{content as string}</Use>
        ),
        // další tagy a odpovídající komponenty
    };

    const components = processTag(text, tagMappings, 0);
    return components;
}

export const getLocation = () => {
    if (!navigator.geolocation) return;

    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            position => {
                const { latitude, longitude } = position.coords;
                resolve({ latitude, longitude });
            },
            error => {
                console.error(error);
                resolve(undefined);
            }
        );
    });
}
